import { render, staticRenderFns } from "./controlpanel.vue?vue&type=template&id=800700ba&"
import script from "./controlpanel.js?vue&type=script&lang=js&"
export * from "./controlpanel.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('800700ba')) {
      api.createRecord('800700ba', component.options)
    } else {
      api.reload('800700ba', component.options)
    }
    module.hot.accept("./controlpanel.vue?vue&type=template&id=800700ba&", function () {
      api.rerender('800700ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/controlpanel.vue"
export default component.exports